import { useNavigate } from 'react-router-dom';

import { LoadWalletMap } from './components';

import { NavBar } from '@/components';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { useGetInitMyAccountExtra } from '@/modules/my-account/hooks/useMyAccount';
import ROUTES from '@/router/routes';

export const AccountMap = () => {
  const isMobile = useIsDesktop();
  const navigate = useNavigate();
  const { data } = useGetInitMyAccountExtra();

  if (isMobile) {
    return (
      <NavBar
        desktop
        mobile={{
          leftContent: {
            backAction: () =>
              navigate(ROUTES.myAccount, {
                replace: true,
              }),
          },
          centerContent: {
            title: 'Kioscos Carga Virtual',
          },
        }}
      >
        <LoadWalletMap className="h-screen" data={data?.initData} />
      </NavBar>
    );
  }
  return <div>AccountMap</div>;
};
